export default __webpack_public_path__ + "static/media/Walk (9).7c8e19d3.png";